<template>
	<div>
		<div class="mainQueryBox">
			<div class="queryLeft">
				<div class="queryBox">
					<span class="queryTitle">省、直辖市：</span>
					<span class="queryValue">
						<el-select size="medium" filterable allow-create v-model="provinces" placeholder="请选择">
							<el-option v-for="(item, index) in provincesGrouped" :label="item" :value="item" :key="index"></el-option>
						</el-select>
					</span>
				</div>
				<div class="queryBox">
					<span class="queryTitle">城市：</span>
					<span class="queryValue">
						<el-select size="medium" @visible-change="visibleChange" filterable allow-create v-model="city" placeholder="请选择">
							<el-option v-for="(item, index) in cityGrouped" :label="item" :value="item" :key="index"></el-option>
						</el-select>
					</span>
				</div>
				<div class="queryBox">
					<span class="queryTitle">任务名称：</span>
					<span class="queryValue"><el-input  size="medium" v-model="taskname" placeholder="请输入标题"></el-input></span>
				</div>
				<el-button  size="medium" type="primary" @click="loadData">搜索</el-button>
				<el-button  size="medium" @click="reset">重置</el-button>
			</div>
			<div><el-button  size="medium" type="primary" @click="addLotteryTask">添加</el-button></div>
		</div>
		<div class="tableBox">
			<el-table  v-loading="loading" border :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				<!-- <el-table-column type="selection" width="55" align="center"></el-table-column> -->
				<el-table-column prop="taskname" label="任务名称" align="center"></el-table-column>
				<el-table-column prop="provinces" label="省、直辖市" align="center"></el-table-column>
				<el-table-column prop="city" label="城市" align="center"></el-table-column>
				<el-table-column prop="partnum" label="已选局号数量" align="center"></el-table-column>
				<el-table-column label="抽取类型" align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.state == 2">生成完成</span>
						<span v-else>生成中</span>
					</template>
				</el-table-column>
				<el-table-column label="抽取状态" align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.randomtype == 1">自定义数量</span>
						<span v-if="scope.row.randomtype == 2">单个样本</span>
						<span v-if="scope.row.randomtype == 3">平均抽样</span>
						<span v-if="scope.row.randomtype == 4">随机抽样</span>
					</template>
				</el-table-column>
				<el-table-column prop="phonenumcount" label="抽取数量" align="center"></el-table-column>
				<el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
				<el-table-column label="操作" align="center" width="220">
					<template slot-scope="scope">
						
						<el-link type="primary" :underline="false" @click="copyData(scope.row)">复制</el-link>
						<el-link type="primary" style="margin-left: 10px;" :underline="false" @click="previewDAta(scope.row.id)">预览</el-link>

						<el-popconfirm style="margin-left: 10px;" title="确定删除吗？" @confirm="delData(scope.row.id)">
							<el-link slot="reference" type="primary" :underline="false">删除</el-link>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
			<div class="block">
				<el-pagination
					background
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="pagination.pageNo"
					:page-sizes="[5, 10, 50, 100, 200, 300, 400]"
					:page-size="pagination.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="pagination.total"
				></el-pagination>
			</div>
		</div>
		<addLotteryTask ref="addLotteryTask" @saveOk="saveOk"></addLotteryTask>
		<previewTableData ref="previewTableData"></previewTableData>
	</div>
</template>

<script>
import addLotteryTask from './addLotteryTask/index.vue';
import previewTableData from './addLotteryTask/previewTableData.vue';
export default {
	components: { addLotteryTask, previewTableData },
	data() {
		return {
			taskname: '',
			city: '',
			cityGrouped: [],
			provinces: '',
			provincesGrouped: [],
			multipleSelection: [],
			tableData: [],
			source: '',
			surveyId: '',
			pagination: {
				pageNo: 1,
				total: 0,
				pageSize: 10
			},
			loading: false
		};
	},
	created() {
		this.surveyId = this.$route.query.id;
		this.source = this.$route.query.source;
		this.loadData();
		this.getPhoneLibProviceGroup();
	},
	methods: {
		delData(id) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.removePhoneTask}`,
				method: 'POST',
				data: {
					id: id
				},
				cb(res) {
					if (res.code == 0) {
						that.loadData();
						that.$message.success(res.message);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		previewDAta(id) {
			this.$refs.previewTableData.openVisible(id);
		},
		saveOk() {
			this.loadData();
		},
		copyData(value) {
			// delete value.id
			// value.randomtype = value.randomtype.toString()
			// this.$refs.addLotteryTask.form = JSON.parse(JSON.stringify(value))
			this.$refs.addLotteryTask.editVisible(value.id);
		},
		addLotteryTask() {
			this.$refs.addLotteryTask.addVisible();
		},
		getPhoneLibProviceGroup() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.getPhoneLibProviceGroup}`,
				method: 'POST',
				data: {
					id: that.surveyId
				},
				cb(res) {
					if (res.code == 0) {
						let arr = res.resultBody;
						let newArr = arr.filter(function(value, index, self) {
							return self.indexOf(value) === index;
						});
						that.provincesGrouped = newArr;
					} else {
						that.provincesGrouped = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		visibleChange(value) {
			console.log(value);
			if (value) {
				let that = this;
				let params = {
					that: this,
					url: `${this.$config.service.getPhoneLibCityGroup}`,
					method: 'POST',
					data: {
						provinces: this.provinces
						// id: id
					},
					cb(res) {
						if (res.code == 0) {
							let arr = res.resultBody;
							let newArr = arr.filter(function(value, index, self) {
								return self.indexOf(value) === index;
							});
							that.cityGrouped = newArr;
						} else {
							// that.$message.error(res.message);
						}
					}
				};
				this.$util.request(params);
			}
		},
		reset() {
			this.city = '';
			this.provinces = '';
			this.loadData();
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		loadData() {
			let that = this;
			this.loading = true
			let params = {
				that: this,
				url: `${this.$config.service.queryPhoneTaskList}`,
				method: 'POST',
				data: {
					id: that.surveyId,
					city: that.city,
					provinces: that.provinces,
					taskname: that.taskname,
					currentPage: that.pagination.pageNo,
					pageSize: that.pagination.pageSize
				},
				cb(res) {
					if (res.code == 0) {
						that.tableData = res.resultBody.records;
						that.pagination.total = res.resultBody.total;
					} else {
						that.tableData = [];
						that.pagination.total = 0;
						that.$message.error(res.message);
					}
				},
				finally() {
					that.loading = false
				}
			};
			this.$util.request(params);
		},
		handleSizeChange(val) {
			this.pagination.pageSize = val;
			this.loadData();
		},
		handleCurrentChange(val) {
			this.pagination.pageNo = val;
			this.loadData();
		}
	}
};
</script>

<style lang="scss" scoped>
.mainQueryBox {
	display: flex;
	justify-content: space-between;
	margin-bottom: 20px;
	.queryLeft {
		display: flex;
		.queryBox {
			display: flex;
			margin-right: 10px;
			align-items: center;
			.queryTitle {
				font-size: 14px;
			}
			.queryValue {
				margin-left: 10px;
			}
		}
		.queryBox:first-child {
			margin-left: 0px;
		}
	}
}

.tableBox {
	.block {
		text-align: right;
		margin-top: 20px;
	}
}
</style>
